import { barChart } from '../charts/barchart';
import { BarchartConfig, BarchartPiece } from '../../source';
import { NotNullProperties } from './helpers';
import { ChartElem } from '../charts';
import { fromNullable } from 'fp-ts/lib/Option';

const render = (props: NotNullProperties, row: BarchartConfig) =>
    barChart(chartElementsByColumns(row.options.columns, props));

const chartElementsByColumns = (
    columns: BarchartPiece[],
    props: NotNullProperties,
) => columns.map(convertColumnToChartElem(props));

// TODO pay attention to type of value which is any in props
const convertColumnToChartElem =
    (props: NotNullProperties) =>
    (column: BarchartPiece): ChartElem => ({
        value: props[column.propName],
        label: fromNullable(column.label).getOrElse(column.propName),
        unit: column.unit,
    });

export default render;
